import { all, call, put, takeLatest } from '@redux-saga/core/effects';
import { REFER_A_FRIEND } from '../actions/referralCode/referralCodeActionConstants';
import { postReferAFriendSuccess } from '../actions/referralCode/referralCodeActions';
import { postReferAFriend } from '../../request/referralCodeRequest';

function* executeReferAFriendButtonClicked({ payload }) {
  try {
    yield call(postReferAFriend, payload);
    yield put(postReferAFriendSuccess(true));
    if (payload.onSuccess) {
      yield call(payload.onSuccess, true);
    }
  } catch (error) {
    if (payload.onError) {
      if (
        error?.response?.data?.Errors &&
        error?.response?.data?.Errors.length > 0
      ) {
        yield call(payload.onError, error?.response?.data?.Errors);
      }
    }
  } finally {
    if (payload?.isLoading) {
      yield call(payload.isLoading, false);
    }
    if (payload?.onConfirm) {
      yield call(payload.onConfirm);
    }
  }
}

export default function* referralCodeSaga() {
  yield all([takeLatest(REFER_A_FRIEND, executeReferAFriendButtonClicked)]);
}
